var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","top":"50%","left":"50%"}})}
var staticRenderFns = []

export { render, staticRenderFns }